export const COUNTRY_OPTIONS = [

  {
    value: "CR",
    label: "Costa Rica"
  },

  {
    value: "US",
    label: "Estados Unidos"
  },

  {
    value: "CA",
    label: "Canadá"
  },

  {
    value: "MX",
    label: "México"
  },

  {
    value: "GB",
    label: "Reino Unido"
  },

  {
    value: "DE",
    label: "Alemania"
  },

  {
    value: "FR",
    label: "Francia"
  },

  {
    value: "ES",
    label: "España"
  },

  {
    value: "NL",
    label: "Países Bajos"
  },

  {
    value: "CH",
    label: "Suiza"
  },

  {
    value: "IT",
    label: "Italia"
  },

  {
    value: "AU",
    label: "Australia"
  },

  {
    value: "AR",
    label: "Argentina"
  },

  {
    value: "BR",
    label: "Brasil"
  },

  {
    value: "CO",
    label: "Colombia"
  },

    {
    value: "other",
    label: "Otro"
  }

];